export const typeSelectOptions = [
  { label: "Grouped", value: "grouped" },
  { label: "Individual", value: "individual" },
];

export const ticketTypeSelectOptions = [
  { label: "Claim", value: "Claim" },
  { label: "Query", value: "Query" },
  { label: "Redirect", value: "Redirect" },
];

export const returnName = (node, depth) => {
  if (depth === 0) {
    return node?.service_name ?? [];
  } else if (depth === 1) {
    return node?.sub_service_name ?? [];
  } else if (depth === 2) {
    return node?.category_name ?? [];
  } else if (depth === 3) {
    return node?.sub_category_name ?? "";
  } else {
    return "unknown";
  }
};

export const returnPlaceHolder = (depth) => {
  if (depth === 0) {
    return "Select Service";
  } else if (depth === 1) {
    return "Select Sub Service";
  } else if (depth === 2) {
    return "Select Cateogory";
  } else {
    return "Select Sub Category";
  }
};

export const returnSelectOptions = (
  val,
  allServices,
  allSubServices,
  allCategories,
  allSubCategories,
) => {
  if (val === 0) {
    return (
      allServices?.map((item) => ({
        label: item?.label,
        value: item.value,
      })) ?? []
    );
  } else if (val === 1) {
    return (
      allSubServices?.map((item) => ({
        label: item?.label,
        value: item.value,
      })) ?? []
    );
  } else if (val === 2) {
    return (
      allCategories?.map((item) => ({
        label: item?.label,
        value: item.value,
      })) ?? []
    );
  } else if (val === 3) {
    return allSubCategories ?? [];
  } else {
    return [];
  }
};

const getLen = (obj) => {
  if (!obj) return 0;
  if (Array.isArray(obj?.sub_services)) return obj.sub_services.length;
  if (Array.isArray(obj?.categories)) return obj.categories.length;
  if (Array.isArray(obj?.sub_categories)) return obj.sub_categories.length;
  if (Array.isArray(obj?.services)) return obj.services.length;
  return 0;
};

export const returnUniqueKey = (child, node, parent, previousParent, depth, ticketType) => {
  const childLength = getLen(child);
  const nodeLenght = getLen(node);
  const parentLength = getLen(parent);
  const previousParentLength = getLen(previousParent);

  const childType = child?.type ?? "";
  const nodeType = node?.type ?? "";
  const parentType = parent?.type ?? "";
  const previousParentType = previousParent?.type ?? "";

  return `${depth}${childLength}${nodeLenght}${parentLength}${previousParentLength}${childType}${nodeType}${parentType}${previousParentType}${ticketType}`;
};

export const returnParentUniqueKey = (node,servicesLength) => {
  const arr = [servicesLength];
  if (node?.ticket_type) arr.push(node?.ticket_type);
  node?.sub_services?.map((item) => {
    arr.push(item?.type)
    if (item?.ticket_type) arr.push(item?.ticket_type);
    if (item?.categories)
    {
      arr.push(item?.categories.length)
      item?.categories.map((c) => {
        arr.push(c?.type)
        if (c?.ticket_type) arr.push(c?.ticket_type);
        if (c?.sub_categories) {
          arr.push(c.sub_categories.length)
          c?.sub_categories.map((s) => {
            arr.push(s?.type)
            if (s?.ticket_type) arr.push(s?.ticket_type);
          })
        }
      })
    }
  })
  

  return `${arr.join("")}`
}